module.exports = __webpack_public_path__ + "static/media/eye.c630a7a9.png";